<div class="wrong-card">
  <div class="wrong-card__icon" aria-hidden="true">
    <svg
      class="wrong-card__svg"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true">
      <path
        d="M15 9L9 15M9 9L15 15M2.586 16.726C2.2109 16.351 2.00011 15.8424 2 15.312V8.688C2.00011 8.15761 2.2109 7.64899 2.586 7.274L7.274 2.586C7.64899 2.2109 8.15761 2.00011 8.688 2H15.312C15.8424 2.00011 16.351 2.2109 16.726 2.586L21.414 7.274C21.7891 7.64899 21.9999 8.15761 22 8.688V15.312C21.9999 15.8424 21.7891 16.351 21.414 16.726L16.726 21.414C16.351 21.7891 15.8424 21.9999 15.312 22H8.688C8.15761 21.9999 7.64899 21.7891 7.274 21.414L2.586 16.726Z"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"/>
    </svg>
  </div>

  <div class="wrong-card__copy">
    <h2 class="wrong-card__title">
      {{ title || (titleKey | translate) }}
    </h2>
    <p class="wrong-card__message">
      {{ subtitle || (subtitleKey | translate) }}
    </p>
  </div>

  <button
    type="button"
    class="btn--primary wrong-card__btn"
    (click)="primaryAction.emit()">
    {{ primaryLabel || (primaryLabelKey | translate) }}
  </button>

  <button
    type="button"
    class="wrong-card__link"
    (click)="secondaryAction.emit()">
    {{ secondaryLabel || (secondaryLabelKey | translate) }}
  </button>

  <div class="wrong-card__footer" *ngIf="showFooter">
    <p>
      {{ 'auth.PoweredBy' | translate }}
      <a [href]="portalUrl" target="_blank" rel="noopener">ZUMConnect</a>
    </p>
  </div>
</div>
